import { DrugPackages, Pass, ATP, MAX, DeviceData, Image, Synmed, DrugGeneralAttributes, DrugDetailsEachOtherBottleSize,SamePillIdRecord } from './../../models/drug-details';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { routePaths } from 'src/app/config/app-constants';
import { ERToolService } from '../../services/er-tool.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ImportWizardImageSlideComponent } from '../import-wizard-image-slide/import-wizard-image-slide.component';
import { DrugCharacteristics } from '../../models/drug-details';
import { HttpErrorResponse } from '@angular/common/http';
import * as constants from 'src/app/config/app-constants';
import { MatTableDataSource } from '@angular/material/table';
import { OtherBottleSizeWizardComponent } from '../other-bottle-size-wizard/other-bottle-size-wizard.component';


@Component({
    selector: 'app-drug-details',
    templateUrl: './drug-details.component.html',
    styleUrls: ['./drug-details.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class DrugDetailsComponent implements OnInit {
  ndc: string;
  dataSourceId: number;
  caseNo: string;
  dataSources: any[] = [];
  drugCharacteristicsModel: DrugCharacteristics = {} as DrugCharacteristics
  otherBottleSizes: DrugDetailsEachOtherBottleSize[] = [];
  dataSourcePill: SamePillIdRecord[] = [];
  drugPackagesModel: DrugPackages = {} as DrugPackages;
  drugGeneralAttributes: DrugGeneralAttributes = {} as DrugGeneralAttributes;
  devicesModel: DeviceData[] = [];
  passModel: Pass = {} as Pass;
  atpModel: ATP = {} as ATP;
  maxModel: MAX = {} as MAX ;
  synmedModel: Synmed = {} as Synmed;
  images: Image = {};
  defaultImage: string = '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'
  dataSource = new MatTableDataSource<DeviceData>();
  drugName?: string;

  displayedColumnsPill: string[] = ['image', 'drugNumber', 'mfg', 'dist', 'qty', 'action'];

  isExpanded: boolean = false;
  isStandard = true; 
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  constructor(
    public ertToolService: ERToolService,
    public dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private activateRoute: ActivatedRoute,
    private toastService: ToastService) {
  }

  ngOnInit(): void {
    this.activateRoute.paramMap.subscribe(params => {
      this.ndc = params.get('ndc');
      this.dataSourceId=Number(params.get('dataSourceId'));
      this.caseNo = params.get('caseNo');
    })
    this.getDrugByndc();
    this.loadAdditionalData();
  }
  displayedColumns: string[] = ['deviceName', 'drugStatus', 'deviceStatus', 'labOptimizedStatus']
  isEditDisable = false;


  openOtherBottleSizesImportWizard() {
      const dialogRef = this.dialog.open(OtherBottleSizeWizardComponent, {
        backdropClass: ['smDialog'],
        disableClose: true,
        data: {
          otherBottleSizes: this.otherBottleSizes,
          title: 'Other Bottle Sizes',
          cancelBtnText: "Cancel",
          confirmBtnText: "Ok",
          confirmButtonColor: "btn-light-blue",
          cancelButtonColor: "btn-light-red",
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log("result", result);
      });
    }


  redirectToDrugPage() {
    this.route.navigate([`/${routePaths.ER_TOOL}`]);
  }

  onSourceChange(event: any): void {
    const selectedValue = event.value;
    this.activateRoute.paramMap.subscribe(params => {
      this.ndc = params.get('ndc');
      this.dataSourceId=Number(selectedValue);
      this.route.navigate([`/${routePaths.ER_TOOL}/drug-details`,  this.ndc,this.dataSourceId,this.caseNo]);
    })
    this.getDrugByndc();
  }
  loadAdditionalData(){
    this.ertToolService.getDrugSourceByNDC(this.ndc).subscribe((response) => {
      this.dataSources = response.data; // Store the fetched data
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        this.toastService.openToast(error.error.message??
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })

  }
  isNullOrUndefinedOrEmpty(value: any){
    return value === undefined || value === null || value === '';
  }
  getColorCodeByStatus(status: string | null): string {
    status = status?.trim();

    switch (status) {
      case 'Do Not Use':
        return '#f06616';           // Color for 'Do Not Use'
      case 'In Production-VS':
        return '#0352ba';
      case 'IN PRODUCTION':
        return '#0352ba';
      case 'IN PRODUCTION':
        return '#0352ba';          // Color for 'In Production-VS'
      case 'LabOptimized':
        return '#403E3E';
      case 'Non-Certified':
          return '#ffa54d';           // Color for 'Non-Certified'
      case '_':
      case null:
        return '';                  // No color for null or '_'
      default:
        return '#403E3E';           // Default light black color for other cases
    }
  }
  getDrugByndc() {
    this.ngxLoader.start();
    this.ertToolService.getDrugDetailsByNdc(this.ndc,this.dataSourceId).subscribe((response) => {
      let result  = response.data;
      if(result.characteristics?.id===0 || result.characteristics?.id==null)
      {
        this.toastService.openToast("No data found for this source",
          constants.ToastPanelType.error,
          2
        );
        this.isEditDisable=true;
        this.ngxLoader.stop();
        return;
      }
      else{
        this.isEditDisable=false;
      }
      this.devicesModel = [];

      this.drugName = result.medName;
      this.otherBottleSizes = result.otherBottleSizes;
      this.dataSourcePill = result.samePillIDRecords;
      //characteristics
      
      this.drugCharacteristicsModel.id = result.characteristics.id;
      this.drugCharacteristicsModel.pillId = result.characteristics.pillId;
      this.drugCharacteristicsModel.active = result.characteristics.active;
      this.drugCharacteristicsModel.genericName =   result.characteristics.genericName;
      this.drugCharacteristicsModel.drugName =   result.characteristics.primaryName;
      this.drugCharacteristicsModel.strength =   result.characteristics.strength;
      this.drugCharacteristicsModel.gpi = result.characteristics.gpi;
      this.drugCharacteristicsModel.gcn = result.characteristics.gcn;
      this.drugCharacteristicsModel.countryCode = result.characteristics.countryCode;
      this.drugCharacteristicsModel.distributor = result.characteristics.distributor;
      const unit = result.characteristics.unit;
        if (unit && unit.includes('||')) {
          const [part1, part2] = unit.split('||');

        if (this.isStandard) {
          this.drugCharacteristicsModel.unit = part2;
        } else {
          this.drugCharacteristicsModel.unit = part1;
        }
      }
       else {
        this.drugCharacteristicsModel.unit = unit;
      }
      this.drugCharacteristicsModel.drugId = result.characteristics.drugId;
      this.drugCharacteristicsModel.dnumber = result.characteristics.dnumber;
      const schedule = result.characteristics.schedule;
      if (schedule && schedule.includes('||')) {
        const [part1, part2] = schedule.split('||');

        if (this.isStandard) {
          this.drugCharacteristicsModel.schedule = part2;
        } else {
          this.drugCharacteristicsModel.schedule = part1;
        }
      }
       else {
        this.drugCharacteristicsModel.schedule = schedule;
      }
      this.drugCharacteristicsModel.antibiotics = result.characteristics.antibiotics;

      const dosageForm = result.characteristics.dosageForm;
      if (dosageForm && dosageForm.includes('||')) {
        const [part1, part2] = dosageForm.split('||');

        if (this.isStandard) {
          this.drugCharacteristicsModel.dosageForm = part2;
        } else {
          this.drugCharacteristicsModel.dosageForm = part1;
        }
      }
       else {
        this.drugCharacteristicsModel.dosageForm = dosageForm;
      }


      this.drugCharacteristicsModel.manufacturer = result.characteristics.manufacturer;
      this.drugCharacteristicsModel.niosh = result.characteristics.niosh;
      this.drugCharacteristicsModel.otc = result.characteristics.otc;
      this.drugCharacteristicsModel.packageSize = result.characteristics.packageSize;
      const packaging = result.characteristics.packaging;
      if (packaging && packaging.includes('||')) {
        const [part1, part2] = packaging.split('||');

        if (this.isStandard) {
          this.drugCharacteristicsModel.packaging = part2;
        } else {
          this.drugCharacteristicsModel.packaging = part1;
        }
      }
       else {
        this.drugCharacteristicsModel.packaging = packaging;
      }

      const roa = result.characteristics.roa;
      if (roa && roa.includes('||')) {
        const [part1, part2] = roa.split('||');

        if (this.isStandard) {
          this.drugCharacteristicsModel.roa = part2;
        } else {
          this.drugCharacteristicsModel.roa = part1;
        }
      }
       else {
        this.drugCharacteristicsModel.roa = roa;
      }

      this.drugCharacteristicsModel.storageConditions = result.characteristics.storageConditions;
      this.drugCharacteristicsModel.unitDose = result.characteristics.unitDose;
      this.drugCharacteristicsModel.unitOfUse = result.characteristics.unitOfUse;
      this.drugCharacteristicsModel.updated = result.characteristics.updated;
      this.drugCharacteristicsModel.drugStatus = result.characteristics.drugStatus;
      this.drugCharacteristicsModel.drugStatusColor = result.characteristics.drugStatusColor;
      this.drugCharacteristicsModel.quarantined = result.characteristics.quarantined;
      this.drugCharacteristicsModel.quarantinedColor = result.characteristics.quarantinedColor;
      this.drugCharacteristicsModel.quarantineReason = result.characteristics.quarantineReason;
      this.drugCharacteristicsModel.oralSolid = result.characteristics.oralSolid;
      const shape = result.characteristics.shape;
      if (shape && shape.includes('||')) {
        const [part1, part2] = shape.split('||');

        if (this.isStandard) {
          this.drugCharacteristicsModel.shape = part2;
        } else {
          this.drugCharacteristicsModel.shape = part1;
        }
      }
       else {
        this.drugCharacteristicsModel.shape = shape;
      }

      this.images.serialImage = `data:image/png;base64,${result?.serialImage == undefined || result?.serialImage == null ? this.defaultImage : result?.serialImage}`;
      this.images.imageName = result.images?.imageName;
      this.drugCharacteristicsModel.drugNumberType = result.characteristics.drugNumberType;
      this.drugCharacteristicsModel.drugNumberFormat = result.characteristics.drugNumberFormat;
      // packages
      const barcode2d = result.characteristics.barcode2d;
      if (barcode2d && barcode2d.includes('||')) {
        const [part1, part2] = barcode2d.split('||');

        if (this.isStandard) {
          this.drugPackagesModel.barcode2d = part2;
        } else {
          this.drugPackagesModel.barcode2d = part1;
        }
      }
       else {
        this.drugPackagesModel.barcode2d = barcode2d;
      }
      this.drugPackagesModel.barcode = result.characteristics.barcode;

      const coating = result.characteristics.coating;
      if(coating && coating.includes('||')){
        const [part1, part2] = coating.split('||');
        
        if(this.isStandard){
          this.drugPackagesModel.coating = part2;
        }else{
          this.drugPackagesModel.coating = part1;
        }
      }
      else{
        this.drugPackagesModel.coating = coating;
      }

      const color = result.characteristics.color;
      if (color && color.includes('||')) {
        const [part1, part2] = color.split('||');

        if (this.isStandard) {
          this.drugPackagesModel.color = part2;
        } else {
          this.drugPackagesModel.color = part1;
        }
      }
       else {
        this.drugPackagesModel.color = color;
      }
      this.drugPackagesModel.imprint1 = result.characteristics.imprint1;
      this.drugPackagesModel.imprint2 = result.characteristics.imprint2;
      const scoring = result.characteristics.scored;
      if(scoring && scoring.includes('||')){
        const [part1, part2] = scoring.split('||');

        if(this.isStandard){
          this.drugPackagesModel.scoring = part2;
        }else{
          this.drugPackagesModel.scoring = part1;
        }
      }
      else{
        this.drugPackagesModel.scoring = scoring;
      }

      this.drugPackagesModel.thirtyDramCapacity = result.characteristics.thirtyDramCapacity;
      this.drugPackagesModel.packageDepth = result.characteristics.packageDepth;
      this.drugPackagesModel.packageHeight = result.characteristics.packageHeight;
      this.drugPackagesModel.packageWidth = result.characteristics.packageWidth;

      // General Attributes
      this.drugGeneralAttributes.length = result?.characteristics?.length;
      this.drugGeneralAttributes.width =  result?.characteristics?.width;
      this.drugGeneralAttributes.classificationShape =  result?.characteristics?.classificationShape;
      this.drugGeneralAttributes.diagonal =  result?.characteristics?.diagonal;
      this.drugGeneralAttributes.pieceWeight =  result?.characteristics?.weight;
      this.drugGeneralAttributes.thickness =  result?.characteristics?.thickness;


      // devices;
      result?.devices.forEach(element => {
        this.devicesModel.push({
          deviceName: element.deviceName,
          rateofUse: element.rateofUse,
          drugStatus: element.drugRecord?.replace('_', ' '),
          deviceStatus: element.deviceName === 'MAX' ? element.maxDrugStatus :
          element.deviceName === 'ATP' ? element.atpDrugStatus :
          element.deviceName === 'PASS' ? element.passDrugStatus :
          element.deviceName === 'SYNMED' ? element.synmedDrugStatus :
          null,
           //element.deviceRecord?.replace('_', ' '),
          deviceStatusColor: element.deviceRecordColor,
          drugRecordColor: element.drugRecordColor,
          labOptimizedStatus: element.labOptimizedStatus
        })

        if (element.deviceName === 'PASS') {
          this.passModel.canisterId = element.canisterId;
          this.passModel.dnuReason = element.dnuReason;
          this.passModel.snapCanisterId = element.snapCanisterId;
          this.passModel.passDrugStatus = element.passDrugStatus;
          this.passModel.passLabOptimized  = element.labOptimizedStatus;
        }
        else if (element.deviceName === 'MAX') {
          this.maxModel.baffle = element.baffle;
          this.maxModel.cellHeight = element.cellHeight;
          this.maxModel.cellWidth = element.cellWidth;
          this.maxModel.diameter = element.diameter;
          this.maxModel.maxDrugStatus = element.maxDrugStatus;
          this.maxModel.doNotUse = element.doNotUse == "1"?"Yes":"No";
          this.maxModel.pressure = element.pressure;
          this.maxModel.thirtyeenDramCapacity = element.thirtyDramDnu == "1"?"Yes":"No";
          this.maxModel.cellCapacity = element.cellCapacity;
          this.maxModel.superCellCapacity = element.superCellCapacity;
          this.maxModel.labOptimizedStatus = element.labOptimizedStatus;
          this.maxModel.isSuperCellOnly = element.isSuperCellOnly == true?"Yes":"No";

        }
        else if (element.deviceName === 'ATP') {
          this.atpModel.diameter = element.tcgDiameter;
          this.atpModel.tcgPillType = element.tcgPillType;
          this.atpModel.pillVolume = element.tcgPillVolume;
          this.atpModel.t1Status = element.tcgT1;
          this.atpModel.t2Status = element.tcgT2;
          this.atpModel.canisterCapacity = element.canisterCapacity;
          this.atpModel.canisterNumber = element.canisterNumber;
          this.atpModel.highCapCanister = element.highCapCapacity;
          this.atpModel.labOptimized = element.labOptimized == true ? 'YES' : 'NO';
          this.atpModel.atpDrugStatus = element.atpDrugStatus
        }
        else if (element.deviceName === 'SYNMED') {
          this.synmedModel.containerSize = element.containerSize;
          this.synmedModel.fragileFlag = element.fragileFlag == true ? 'YES' : 'NO';
          this.synmedModel.lidHoleSize = element.lidHoleSize;
          this.synmedModel.lidVolcanic = element.lidVolcanic == true ? 'YES' : 'NO';
          this.synmedModel.pipetteSize = element.pipetteSize;
          this.synmedModel.toggleFlag = element.toggleFlag == true ? 'YES' : 'NO';
          this.synmedModel.massIndex = element.massIndex;
          this.synmedModel.synmedDrugStatus = element.synmedDrugStatus;
          this.synmedModel.labOptimizedStatus = element.labOptimized == true ? 'YES' : 'NO';
          this.synmedModel.nonCountReasonId = element.nonCountReasonId;
          this.synmedModel.dnuReason = element.dnuReason;
          this.synmedModel.preferredLidHoleSize = element.preferredLidHoleSize;
          this.synmedModel.preferredContainerSize = element.preferredContainerSize;
          this.synmedModel.preferredPipetteSize = element.preferredPipetteSize;
          this.synmedModel.largePipetteDropHeight = element.largePipetteDropHeight;
          this.synmedModel.smallPipetteDropHeight = element.smallPipetteDropHeight;

        }
      });
      this.dataSource.data = this.devicesModel
      this.ngxLoader.stop();
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        this.toastService.openToast(error.error.message??
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })

  }
  openImportWizardImageSlide() {

    const dialogRef = this.dialog.open(ImportWizardImageSlideComponent, {
      backdropClass: ['mdDialog'],
      disableClose: true,
      data: { ndc: this.drugCharacteristicsModel.drugId, dataSource: this.dataSourceId }
    });

  }

  onToggleSourceChange(event : any){
    this.isStandard = event.checked;
    this.getDrugByndc();
  }

  get formattedGpi(): string {
    const gpi = (this.drugCharacteristicsModel.gpi ?? '') +
                (this.drugCharacteristicsModel.gcn ?? '');
    return gpi.replace('--', '');
  }

}
